export function isArrayEmptyOrNull(arr?: any[] | null): boolean {
  return !arr?.length;
}

export function isObjectEmptyOrNull(obj?: any | null): boolean {
  return !(obj && Object.keys(obj).length);
}
